export class RecentSearch {
  public airports: Airports | Airports[];
  public selectTripType: string;
  public dates: Dates | Dates[];
  public passenger: number;
  public swapedFromCity: any;
  public swapedToCity: any;
  public schedulePrice: any;
  public faresFor: string;
  public meetingEventCode: string;
  public refundableFlightsOnly: any;
  public nearbyAirports: any;
  public deltaOnly: string;
  public awardTravel: boolean;
  public departureTime: string;
  public returnTime: string;
  public adtCount: any;
  public cnnCount: any;
  public gbeCount: any;
  public infantCount: any;
  public chkFlexDate: boolean;
  public includeBasicFaresUnchecked: boolean;

  public constructor(d: any) {
    this.adtCount = d.adtCount === '' ? '0' : d.adtCount;
    this.airports = d.airports;
    this.awardTravel = d.awardTravel;
    this.cnnCount = d.cnnCount === '' ? '0' : d.cnnCount;
    this.dates = d.dates;
    this.deltaOnly = d.deltaOnly;
    this.departureTime = d.departureTime;
    this.faresFor = d.faresFor;
    this.gbeCount = d.gbeCount === '' ? '0' : d.gbeCount;
    this.infantCount = d.infantCount === '' ? '0' : d.infantCount;
    this.meetingEventCode = d.meetingEventCode;
    this.nearbyAirports = d.nearbyAirports;
    this.passenger = d.passenger;
    this.refundableFlightsOnly = d.refundableFlightsOnly;
    this.returnTime = d.returnTime;
    this.schedulePrice = d.schedulePrice;
    this.selectTripType = d.selectTripType;
    this.swapedFromCity = d.swapedFromCity;
    this.swapedToCity = d.swapedToCity;
    this.chkFlexDate = d.chkFlexDate;
    this.includeBasicFaresUnchecked = d.includeBasicFaresUnchecked;
  }
}

export class Airports {
  public fromCity: string;
  public toCity: string;
  public fromAirportcode: string;
  public toAirportcode: string;
  public fromCountryCode: string;
  public toCountryCode: string;
  connectionAirport: string;
  connectionCity: string;
  invalidAirportCodes: string;

  public constructor(d: any) {
    this.fromCity = d.fromCity;
    this.toCity = d.toCity;
    this.fromAirportcode = d.fromAirportcode;
    this.toAirportcode = d.toAirportcode;
    this.fromCountryCode = d.fromCountryCode ?? d.fromCountryCd;
    this.toCountryCode = d.toCountryCode ?? d.toCountryCd;
  }
}

export class Dates {
  public departureDate: string;
  public returnDate: string;

  public constructor(d: any) {
    this.departureDate = d.departureDate;
    this.returnDate = d.returnDate;
  }
}

export class SchedulePrice {
  public value: string;

  public constructor(d: any) {
    this.value = d.value;
  }
}
